export const CARDS_ROUTES = ['/cartoes', '/cartoes/adquirir-oferta'] as const
